import logo1999UK from "../../assets/img/historicEvents/LogoNoMercy/1999UK.png";
import logo1999 from "../../assets/img/historicEvents/LogoNoMercy/1999.png";
import logo2000_2001 from "../../assets/img/historicEvents/LogoNoMercy/2000-2001.png";
import logo2002 from "../../assets/img/historicEvents/LogoNoMercy/2002.png";
import logo2003 from "../../assets/img/historicEvents/LogoNoMercy/2003.png";
import logo2004 from "../../assets/img/historicEvents/LogoNoMercy/2004.png";
import logo2005 from "../../assets/img/historicEvents/LogoNoMercy/2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoNoMercy/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoNoMercy/2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoNoMercy/2008.png";
import logo2016 from "../../assets/img/historicEvents/LogoNoMercy/2016.png";
import logo2017 from "../../assets/img/historicEvents/LogoNoMercy/2017.png";

export const noMercyDetail = {
  "no-mercy": {
    id: "no-mercy",
    title: "No Mercy",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "no-mercy",
        items: [
          {
            id: "no-mercy-1999-uk",
            title: "No Mercy UK",
            description: "Manchester, England 1999",
            imgUrl: logo1999UK,
          },
          {
            id: "no-mercy-1999",
            title: "No Mercy",
            description: "Show No Compassion, Remorse or Mercy 1999",
            imgUrl: logo1999,
          },
          {
            id: "no-mercy-2000",
            title: "No Mercy",
            description: "2000 - 2001",
            imgUrl: logo2000_2001,
          },
          {
            id: "no-mercy-2002",
            title: "No Mercy",
            description: "2002",
            imgUrl: logo2002,
          },
          {
            id: "no-mercy-2003",
            title: "No Mercy",
            description: "2003",
            imgUrl: logo2003,
          },
          {
            id: "no-mercy-2004",
            title: "No Mercy",
            description: "2004",
            imgUrl: logo2004,
          },
          {
            id: "no-mercy-2005",
            title: "No Mercy",
            description: "2005",
            imgUrl: logo2005,
          },
          {
            id: "no-mercy-2006",
            title: "No Mercy",
            description: "2006",
            imgUrl: logo2006,
          },
          {
            id: "no-mercy-2007",
            title: "No Mercy",
            description: "2007",
            imgUrl: logo2007,
          },
          {
            id: "no-mercy-2008",
            title: "No Mercy",
            description: "2008",
            imgUrl: logo2008,
          },
          {
            id: "no-mercy-2016",
            title: "No Mercy",
            description: "2016",
            imgUrl: logo2016,
          },
          {
            id: "no-mercy-2017",
            title: "No Mercy",
            description: "2017",
            imgUrl: logo2017,
          },
        ],
      },
    ],
  },
};
